import React, { useContext, useMemo } from 'react';

import { useForm, Form, CreateForm } from '../../../hooks/useForm';
import useSharedEfaktura, { SharedEfakturaType } from '../hooks/useSharedEfaktura';
import { EfakturaSharingAction, EfakturaSharingActionType } from './actions';
import EfakturaSharingState from './state';
import { EFakturaError } from './validate';

type EfakturaFormContext = {
    form: Form<EfakturaSharingState, EfakturaSharingAction, EFakturaError, EfakturaSharingActionType>;
} & SharedEfakturaType;

const FormContext = React.createContext<EfakturaFormContext | undefined>(undefined);

export default () => {
    const context = useContext(FormContext) as EfakturaFormContext;

    if (context === undefined) {
        throw new Error('useFormContext must be used within FormContext');
    }

    return context;
};

export const EfakturaSharingFormContext = ({
    validateHook,
    reducer,
    initialState,
    children,
}: CreateForm<EfakturaSharingState, EfakturaSharingAction, EFakturaError>) => {
    const form = useForm<EfakturaSharingState, EfakturaSharingAction, EFakturaError, EfakturaSharingActionType>(
        validateHook,
        reducer,
        initialState,
    );
    const sharedEfaktura = useSharedEfaktura();
    const contextValue = useMemo(
        () => ({
            form,
            ...sharedEfaktura,
        }),
        [form, sharedEfaktura],
    );
    return <FormContext.Provider value={contextValue}>{children}</FormContext.Provider>;
};
